<template>
	<div class="Menu">

		<!-- heading start -->

		<AppHeading
			v-if="client && client.style === 'modern'"
			:title="client.name"
			:subtitle="headingSubtitle"
			:isButton="true"
			:isButtonCondition="selectedCategory"
			@isButtonClicked="clearSelectedCategory"
		/>

		<!-- heading end -->

		<!-- content start -->

		<AppLoading
			v-if="productsLoading"
			style="padding: 0 16px;"
		/>

		<AppNoData
			v-else-if="!productsLoading && !productsFiltered.length"
			text="Sorry, no products at the moment :("
			style="padding: 0 16px;"
		/>

		<div
			v-else
			class="content"
		>
			<div class="container">
				<MasterCategoriesList
					v-if="masterCategories"
					:list="masterCategories"
					:selectItem="selectCategory"
				/>

				<template v-if="client.style === 'classic'">
					<CategoriesContent
						:list="productsFilteredClassic"
						:selectProduct="selectProduct"
					/>
				</template>

				<template v-else>
					<ProductsList
						:list="productsFiltered"
						:selectProduct="selectProduct"
					/>
				</template>
			</div>
		</div>

		<!-- content end -->

	</div>
</template>

<script>
/* eslint-disable max-len */
import { mapGetters, mapActions } from 'vuex'

import AppLoading from '../components/AppLoading.vue'
import AppNoData from '../components/AppNoData.vue'
import AppHeading from '../components/AppHeading.vue'
import CategoriesContent from '../components/CategoriesContent.vue'
import MasterCategoriesList from '../components/MasterCategoriesList.vue'

import ProductsList from '../components/ProductsList.vue'

export default {
	components: {
		AppLoading,
		AppNoData,
		AppHeading,
		CategoriesContent,
		ProductsList,
		MasterCategoriesList,
	},

	computed: {
		...mapGetters({
			selectedCategory: 'categories/selectedCategory',

			products: 'products/products',
			productsLoading: 'products/productsLoading',
			masterCategories: 'categories/masterCategories',
			selectedMasterCategory: 'categories/selectedMasterCategory',
		}),

		headingSubtitle () {
			return this.selectedCategory ? this.getTranslation(this.selectedCategory.name) : 'Menu'
		},

		productsFiltered () {
			if (this.selectedCategory) {
				return this.products.filter((item) => this.selectedCategory.id === item.categories[0].id)
			}

			return this.products
		},

		productsFilteredClassic () {
			const categories = {}

			if (this.masterCategories.length) {
				const selectedCategoriesIds = this.selectedMasterCategory.categories.map((category) => category.id)

				const filteredProducts = this.products.filter((product) => {
					const filteredCategories = product.categories.filter((category) => selectedCategoriesIds.includes(category.id))

					return filteredCategories.length
				})

				filteredProducts.forEach((product) => {
					if (!categories[product.categories[0].id]) {
						categories[product.categories[0].id] = {
							categories: product.categories,
							items: [],
						}
					}

					categories[product.categories[0].id].items.push(product)
				})
			} else {
				this.products.forEach((product) => {
					if (!categories[product.categories[0].id]) {
						categories[product.categories[0].id] = {
							categories: product.categories,
							items: [],
						}
					}

					categories[product.categories[0].id].items.push(product)
				})
			}

			return categories
		},
	},

	mounted () {
		if (!this.products.length) this.getProducts()

		this.selectCategory(this.masterCategories[0])
	},

	methods: {
		...mapActions({
			getProducts: 'products/getProducts',
			updateSelectedCategory: 'categories/updateSelectedCategory',
			updateSelectedMasterCategory: 'categories/updateSelectedMasterCategory',
		}),

		selectProduct (product) {
			this.$router.push({
				name: 'menu-item-details',
				params: {
					categoryId: product.categories[0].id,
					productId: product.id,
					selectedItem: product,
				},
			})
		},

		clearSelectedCategory () {
			this.updateSelectedCategory()
		},

		selectCategory (item = null) {
			this.updateSelectedMasterCategory(item)
		},
	},
};
</script>

<style lang="scss">
	.category-list {
		padding: 0;
		margin: 0;
		list-style: none;

		&__item {
			display: flex;
			font-size: 18px;
			line-height: 20px;
			padding: 16px 0;
		}
	}
</style>
